/**
 * 実行時のホスト名がローカル（localhost / 127.0.0.1 / [::1]）かどうかを判定する。
 * ビルド時の env と違い、本番ドメインへ配布された成果物では絶対に true にならないため、
 * ローカル確認用の暫定表示の判定に使う。
 * @returns ローカルホストで実行中の場合は true
 */
export const isLocalHost = (): boolean => {
  if (typeof window === "undefined") return false;
  return ["localhost", "127.0.0.1", "[::1]"].includes(window.location.hostname);
};
